import type { FlagSubMenuV9Props } from './components/FlagSubMenuV9';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, LazyAction, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "FlagMenu"*/ './lazyIndex'),
    {
        name: 'FlagMenu',
    }
);

export const lazyShowFlagDateTimePicker: LazyAction<
    typeof lazyIndex.showFlagDateTimePicker,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showFlagDateTimePicker);
export const FlagSubMenuV9: LazyComponent<FlagSubMenuV9Props, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.FlagSubMenuV9
);
